module.exports = __webpack_public_path__ + "img/P150T_weapon_27.5bbb1ff4.png";